import { Info, PackageMinus, PackagePlus } from 'lucide-react'
import { useInventoryStore } from '../store/inventoryStore'
import type { InventoryTransaction } from '@/features/inventory/types/inventory'
import { Button } from '@/components/ui/button'
import { formatDate } from '@/utils/timeZoneUtils'
import { Badge } from '@/components/ui/badge'

interface TransactionCardProps {
  transaction: InventoryTransaction
  onDetail: (itemId: string) => void
}

export function TransactionCard({
  transaction,
  onDetail,
}: TransactionCardProps) {
  const categories = useInventoryStore((s) => s.categories)
  const inventoryStock = useInventoryStore((s) => s.inventoryStock)

  const item = inventoryStock.find((def) => def.item === transaction.item)
  const category = categories.find((cat) => cat._id === item?.categoryId)

  return (
    <div className="border rounded-lg p-4 hover:shadow-md transition-shadow bg-white">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-lg">
          {item?.item} {item?.brand && `(${item.brand})`}
        </div>

        {transaction.type === 'IN' ? (
          <Badge
            variant="outline"
            className="text-sm inline-flex items-center gap-2 text-green-600 border-green-300 bg-green-100"
          >
            <PackagePlus className="h-3 w-3" />
            <span>In</span>
          </Badge>
        ) : (
          <Badge
            variant="default"
            className="text-sm inline-flex items-center gap-2 text-red-600 border-red-300 bg-red-100"
          >
            <PackageMinus className="h-3 w-3" />
            Out
          </Badge>
        )}
      </div>

      <div className="space-y-2 mb-4">
        <div className="text-sm">
          <span className="font-medium text-gray-600">Date: </span>
          <span>{formatDate(transaction.createdAt)}</span>
        </div>
        <div className="text-sm">
          <span className="font-medium text-gray-600">Category: </span>
          <span>{category?.name}</span>
        </div>
        <div className="text-sm">
          <span className="font-medium text-gray-600">Quantity: </span>
          <span>{transaction.quantity}</span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="grid gap-2">
        {/* Details Button - only show for pastors */}
        <Button
          variant="outline"
          size="sm"
          className="w-full sm:w-auto"
          onClick={() => {
            console.log('Detail clicked for', transaction._id)
            onDetail(transaction._id)
          }}
        >
          <Info className="h-4 w-4 sm:mr-2" /> Details
        </Button>

        {/* <Button
          variant="outline"
          size="sm"
          className="w-full sm:w-auto"
          onClick={() => onEdit(item._id)}
        >
          <Edit className="h-4 w-4 sm:mr-2" /> Edit
        </Button> */}

        {/* <Button
          variant="destructive"
          size="sm"
          className="w-full sm:w-auto"
          onClick={() => onDelete(category._id)}
        >
          <Trash2 className="h-4 w-4 sm:mr-2" /> Delete
        </Button> */}
      </div>
    </div>
  )
}
